import React from "react"
import classNames from "classnames"
import useOpenCourses from "hooks/useOpenCourses"
import useCourseTypes from "hooks/useCourseTypes"
import "./Steps.css"


const TERMS_URL = "https://public.sailweek.com/legal/terms"
const CONSENT_EMAIL = "info@sailweekacademy.com"

export default function Step5(props) {

    const {getCourse} = useOpenCourses()
    const {getType} = useCourseTypes()
    const {data, update, invalid, disabled} = props
    const course = getCourse(data.courseId)
    const type = getType(course.type)

    return <section className="step" id="step-5">
        <div className="step-label">Step 5 of 5</div>
        <h2>Check and confirm</h2>        
        <p>Please check your data and click the &apos;Apply&apos; button</p>
        
        
        <div className="inputs" id="confirm">
            <div className="field">Course:</div><div>{type.name}</div>
            <div className="field">First name:</div><div>{data.givenName}</div>
            <div className="field">Last name:</div><div>{data.familyName}</div>
            <div className="field">Birthdate:</div><div>{data.birthdate}</div>
            <div className="field">Gender:</div><div>{data.gender}</div>
            <div className="field">Nationality:</div><div>{data.nationality}</div>
            <div className="field">Email address:</div><div>{data.email}</div>
            <div className="field">Phone:</div><div>{data.phone}</div>
            <div className="field">LinkedIn profile:</div><div>{data.linkedIn}</div>
            <div className="field">Licence:</div><div>{data.licence}</div>
            <div className="field">CV:</div><div>{data.uploadFilename}</div>
            <div className="field">Notes:</div><div>{data.notes}</div>
        </div>

        <div id="consents">
            <div className="checkbox">
                <input id="english" type="checkbox" checked={data.english} disabled={disabled} onChange={e => update('english', e.target.checked)}/>
                <label htmlFor="english" className={classNames({invalid: invalid.includes('english')})}>I hereby confirm that I am proficient in spoken and written English</label>
            </div>

            <div className="checkbox">
                <input id="terms" type="checkbox" checked={data.terms} disabled={disabled} onChange={e => update('terms', e.target.checked)}/>
                <label htmlFor="terms" className={classNames({invalid: invalid.includes('terms')})}>I have read and accept the <a href={TERMS_URL} target="_blank" rel="noreferrer">Terms &amp; Conditions</a></label>
            </div>

            <div className="checkbox">
                <input id="photo-consent" type="checkbox" checked={data.photoConsent} disabled={disabled} onChange={e => update('photoConsent', e.target.checked)}/>
                <label htmlFor="photo-consent">
                    <span className="optional">Optional:</span> I agree that Sailweek Limited may use photographs and videos in which I am identifiable to promote Sailweek Academy on its website, social media and marketing materials. This choice is optional and does not affect my booking. I can withdraw consent for future use by contacting <a href={`mailto:${CONSENT_EMAIL}`}>{CONSENT_EMAIL}</a>.
                </label>
            </div>
        </div>

    </section>
}